import { Taxon } from 'src/app/domain/Analyse/taxon';
import { WaterProcess } from 'src/app/domain/EAU/water-process';
import { IBDProcess } from 'src/app/domain/IBD/IDB-process';
import { IBGNProcess } from 'src/app/domain/IBGN/IBGN-process';
import { IBMRProcess } from 'src/app/domain/IBMR/IBMR-process';
import { IMLProcess } from 'src/app/domain/IML/IML-process';
import { LacProcess } from 'src/app/domain/Lac - EAU/lac-process';
import { MGCEProcess } from 'src/app/domain/MGCE/MGCE-Process';
import { Process } from 'src/app/domain/MPCE/process';
import { Intervention } from 'src/app/domain/planning/intervention';
import { SampleTakingModel } from 'src/app/models/new-substrat-model';
import { InterventionUpdateDTO } from './intervention-update.dto';

export class InterventionOfflineUpdateDto {
    public Intervention: InterventionUpdateDTO;
    public Environment: Intervention;

    // MPCE
    public MPCEStation: Process;
    public MPCESubstrats: SampleTakingModel[];

    // IBGN
    public IBGNStation: IBGNProcess;
    public IBGNSubstrats: SampleTakingModel[];

    // IBD
    public IBDProcess: IBDProcess;

    // WATER
    public WaterProcess: WaterProcess;

    // Lac
    public LacProcess: LacProcess;

    // MGCE
    public MGCEProcess: MGCEProcess;

    // IBMR
    public IBMRProcess: IBMRProcess;
    public IBMRTaxonList: Taxon[] = [];

    // IML
    public IMLProcess: IMLProcess;
}
